import { NgModule, ErrorHandler } from '@angular/core';
import { CommonTLFModule } from '../common/common.module';
import { SearchCacheService } from '../common/services/search.cache.service';
import { AdempimentiInevasiListComponent } from './components/adempimenti-inevasi/adempimenti-inevasi-list.component';
import { AdempimentiInevasiViewComponent } from './components/adempimenti-inevasi/adempimenti-inevasi-view.component';
import { AdempimentiInevasiComponent } from './components/adempimenti-inevasi/adempimenti-inevasi.component';
import { AttivitaCompletareListComponent } from './components/attivita-completare/attivita-completare-list.component';
import { AttivitaCompletareViewComponent } from './components/attivita-completare/attivita-completare-view.component';
import { AttivitaCompletareComponent } from './components/attivita-completare/attivita-completare.component';
import { HelpersService } from './services/helpers.service';
import { HeaderComponent } from './components/header/header.component';
import { CtxMenuComponent } from './components/ctxMenu/ctx-menu.component';
import { WelcomeBoardComponent } from './components/body/welcome-board.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { ConfirmModal } from './components/confirmModal/confirm-modal.component';
import { TeleforumErrorHandler } from './components/exception-manager/teleforum-error-handler';
import { IndexFooterComponent } from './components/footer/index-footer.component';
import { HeaderNavComponent } from './components/header-nav/header-nav.component';
import { NotificationsViewComponent } from './components/notifications/notifications-view.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { NotificheListComponent } from './components/notifications/notifiche-list.component';
import { NotifyComponent } from './components/notify/notify.component';
import { ProssimiAdempimentiListComponent } from './components/prossimi-adempimenti/prossimi-adempimenti-list.component';
import { ProssimiAdempimentiViewComponent } from './components/prossimi-adempimenti/prossimi-adempimenti-view.component';
import { ProssimiAdempimentiComponent } from './components/prossimi-adempimenti/prossimi-adempimenti.component';
import { UserComponent } from './components/user/user.component';
import { PageLoadingComponent } from './components/page-loading/page-loading.component';
import { ConfigurationUtilService } from './services/configuration-util-service';
import { GestioneProfiliUtenteService } from './services/gestione-profili-utente.service';
import { ModalNotifyService } from './services/modal-notify.service';
import { OperationsService } from './services/operations.service';
import { ReportService } from './services/report.services';
import { RoutingConfigurationUtilService } from './services/routing-configuration-util.service';
import { UserManager } from './services/user-manager';
import { ViewManagerService } from './services/view-manager-service';
import {
  HttpClientModule,
  HttpXhrBackend,
  HttpRequest,
  HttpClient,
} from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CalendarModule } from 'angular-calendar';
import { LoginComponent } from './components/login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DefineTemplate } from '../common/components/option-component/optionFascicolo/templateComponent/define-template';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { DialogModule } from './components/dialog/dialog.module';
import { DocumentManagementModule } from '../document-management/document-management.module';
import { GestioneSocietaModule } from '../lem/pages/amministrazione/gestionesocieta-lem.module';
import { PersonModule } from '../lem/pages/person/person.module';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { UploadProgressComponent } from './components/upload-progress/upload-progress.component';
import {PraticaModule} from "../pratica/pratica.module";
import { DipartimentiModule } from '../lem/pages/dipartimenti/dipartimenti.module';
import { ModalSyncCalendarComponent } from './components/modal-sync-calendar/modal-sync-calendar.component';
import { ResponsiveHeaderComponent } from './components/responsive-header/responsive-header.component';
import { PraticaSelectionComponent } from './components/pratica-selection/pratica-selection.component';
import { UploadToolComponent } from './components/upload-tool/upload-tool.component';
import { PdaModule } from '../pda/pda.module';
import { DialogRef } from './components/dialog/dialog-ref';
// import { TeleforumUiModule } from 'teleforum-ui'; DASHBOARD COMMENT
import { OutlookAuthLpComponent } from './components/login/outlook-auth-lp/outlook-auth-lp.component';
import { RefreshTokenLpComponent } from './components/login/outlook-auth-lp/refresh-token-lp/refresh-token-lp.component';
import { ForbiddenComponent } from './components/forbidden/forbidden.component';
import { ProfiloUtenteComponent } from './components/profilo-utente/profilo-utente.component';


@NgModule({
  imports: [
    CommonTLFModule,
    RouterModule,
    CommonModule,
    CalendarModule,
    ReactiveFormsModule,
    FormsModule,
    DialogModule,
    DocumentManagementModule,
    GestioneSocietaModule,
    DipartimentiModule,
    PersonModule,
    PraticaModule,
    UploadToolComponent,
    PdaModule,
    // TeleforumUiModule DASHBOARD COMMENT
  ],

  providers: [
    HelpersService,
    ViewManagerService,
    ModalNotifyService,
    OperationsService,
    ReportService,
    ConfigurationUtilService,
    SearchCacheService,
    GestioneProfiliUtenteService,
    UserManager,
    DialogRef,
    RoutingConfigurationUtilService,
    {
      provide: HttpClient,
      useFactory: (
        backend: HttpXhrBackend,
        defaultOptions: HttpRequest<any>,
      ) => new HttpClient(backend),
      deps: [HttpXhrBackend, HttpRequest],
    } /*, { // todo: ripristinare provide hide error
      provide: ErrorHandler,
      useClass: TeleforumErrorHandler
    }*/,
  ],

  declarations: [
    HeaderComponent,
    CtxMenuComponent,
    WelcomeBoardComponent,
    IndexFooterComponent,
    HeaderNavComponent,
    UserComponent,
    NotificationsComponent,
    NotifyComponent,
    ConfirmModal,
    ProssimiAdempimentiComponent,
    ProssimiAdempimentiViewComponent,
    ProssimiAdempimentiListComponent,
    AdempimentiInevasiComponent,
    AdempimentiInevasiViewComponent,
    AdempimentiInevasiListComponent,
    NotificheListComponent,
    AttivitaCompletareComponent,
    AttivitaCompletareListComponent,
    NotificationsViewComponent,
    AttivitaCompletareViewComponent,
    PageLoadingComponent,
    ErrorPageComponent,
    LoginComponent,
    DefineTemplate,
    NotFoundComponent,
    ProfiloUtenteComponent,
    ProgressBarComponent,
    UploadProgressComponent,
    ModalSyncCalendarComponent,
    ResponsiveHeaderComponent,
    PraticaSelectionComponent,
    OutlookAuthLpComponent,
    RefreshTokenLpComponent,
    ForbiddenComponent
  ],

  exports: [
    HeaderComponent,
    CtxMenuComponent,
    WelcomeBoardComponent,
    IndexFooterComponent,
    HeaderNavComponent,
    UserComponent,
    NotificationsComponent,
    NotifyComponent,
    ConfirmModal,
    ProssimiAdempimentiComponent,
    ProssimiAdempimentiViewComponent,
    ProssimiAdempimentiListComponent,
    AdempimentiInevasiComponent,
    AdempimentiInevasiViewComponent,
    AdempimentiInevasiListComponent,
    PageLoadingComponent,
    ErrorPageComponent,
    LoginComponent,
    DefineTemplate,
    NotFoundComponent,
    ProfiloUtenteComponent,
    UploadToolComponent,
    ProgressBarComponent,
    UploadProgressComponent,
    ResponsiveHeaderComponent,
    ForbiddenComponent
  ],
})
export class CoreModule {}
